// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import useFilteredVariantTraits from "@insite/client-framework/Common/Hooks/useFilteredVariantTraits";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import {
    getProductState,
    getVariantChildrenDataView,
} from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import {
    chain,
    SetVariantSelection,
} from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/UpdateVariantSelection";
import { ProductModel, VariantTraitModel } from "@insite/client-framework/Types/ApiModels";

export const ChangeVariantSelection = (props: any) => {
    const variantTraits = getProductState(props.getState(), props.parameter.productId).value?.variantTraits;
    const variantChildren = getVariantChildrenDataView(props.getState(), props.parameter.productId).value;
    const variantSelection = props.getState().pages.productDetails.variantSelection;

    const filteredVariantTraits = useFilteredVariantTraits(
        variantTraits as VariantTraitModel[],
        variantChildren as ProductModel[],
        variantSelection,
    );
    const vTraits = filteredVariantTraits.filter((variant: any) => !!variant.traitValues?.length);

    const variants = {} as any;
    (vTraits || []).forEach(variant => {
        variants[variant.id] = props.variantSelection[variant.id] || "";
    });
    props.variantSelection = variants;
};

addToChainAfter(chain, SetVariantSelection, ChangeVariantSelection);
